/**
 * @generated SignedSource<<b7072f798dfad6b7650a2437bbffeb9a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedItemsGrid_user$data = {
  readonly twoTowerModelItemRecommendations: {
    readonly recommendationIds: ReadonlyArray<string>;
  } | null;
  readonly " $fragmentType": "HpSharedItemsGrid_user";
};
export type HpSharedItemsGrid_user$key = {
  readonly " $data"?: HpSharedItemsGrid_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedItemsGrid_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": "PERSONALIZED",
      "kind": "LocalArgument",
      "name": "recommendationType"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedItemsGrid_user",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "type",
          "variableName": "recommendationType"
        }
      ],
      "concreteType": "UserRecommendations",
      "kind": "LinkedField",
      "name": "twoTowerModelItemRecommendations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "recommendationIds",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "e3b7a0ebd2de562b3ba9f7c4a6711d73";

export default node;
